<template>
  <Modal v-bind="$attrs" v-on="$listeners" @closed="closed">
    <template #title>
      <div class="text-sm font-bold text-gray-700">物件を追加<span class="ml-3 font-normal text-gray-500">{{ clientName }}</span></div>
    </template>
    <div>
      <div class="overflow-auto rounded main-height">
        <div v-if="!list.length" class="w-full flex justify-center items-center py-10">
          <p class="text-gray-400 font-bold">追加できる物件がありません</p>
        </div>
        <table v-else class="mx-1 mb-12">
          <thead class="sticky top-0 bg-white">
            <tr>
              <th scope="col" class="px-3 py-3 text-center text-xs font-medium text-gray-500 tracking-wider whitespace-nowrap">
                <span class="text-blue-700 cursor-pointer font-bold mr-3" @click="allCheck(true)">全選択（契約中）</span>
                <span class="text-blue-700 cursor-pointer font-bold" @click="allCheck(false)">全解除</span>
              </th>
              <th scope="col" class="px-6 py-3 text-center text-xs font-medium text-gray-500 tracking-wider" colspan="3">
                <input
                  type="search"
                  name="site"
                  placeholder="物件名 検索"
                  class="w-full py-2 pr-3 border border-gray-300 rounded-md leading-5 focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900"
                  v-model="filter"
                />
              </th>
            </tr>
            <tr class="border border-gray-200">
              <th scope="col" class="px-3 py-3 text-left text-xs font-medium text-gray-500 tracking-wider bg-colu">選択</th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider bg-colu">物件コード</th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider bg-colu">物件名</th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider bg-colu">契約</th>
            </tr>
          </thead>

          <tr v-for="(row, i) in filteredList" :key="i" class="border border-gray-200 tracking-wider h-10 cursor-pointer hover-color" :class="isChecked(row)?'bg-yellow-100':''" @click="clickRow(row)">
            <!-- 選択 -->
            <td class="b-top px-3 py-3 whitespace-nowrap text-sm font-medium text-gray-500 text-center">
              <input
                type="checkbox"
                class="cursor-pointer h-4 w-4 rounded"
                :checked="isChecked(row)"
                @click.stop="clickRow(row)"
              >
            </td>

            <!-- 物件コード -->
            <td class="px-6 py-3 whitespace-nowrap text-sm text-blue-700 font-bold">
              {{ row.siteCode }}
            </td>

            <!-- 物件名 -->
            <td class="px-6 py-3 whitespace-nowrap text-sm text-gray-700 min-300">
              {{ row.site1 }} {{ row.site2 }}
              <p v-if="row.address1 || row.address2" class="text-xs text-gray-400">{{ row.address1 }}{{ row.address2 }}</p>
            </td>

            <!-- 契約状況 -->
            <td class="px-6 py-3 whitespace-nowrap text-sm" :class="isActive(row)?'text-gray-700':'text-red-700 font-bold'">
              {{ row.agreementFlg }}
            </td>
          </tr>
        </table>
      </div>
      <div>
        <PrimaryButton :text="'追加（' + selected.length + '件）'" size="normal mt-3 w-full" :disabled="!selected.length" @click="selectedBtn()" />
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '@components/Modal.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import * as utils from '@libs/utils'

export default {
  components: {
    Modal,
    PrimaryButton
  },

  props: {
    open: {
      type: Boolean,
      default: false
    },
    // 追加できる物件（選んだ得意先の物件から、既に選んでいる物件を除いたもの）
    list: {
      type: Array,
      default: () => []
    },
    // 得意先名（見出しに出す）
    clientName: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      // 物件名 検索
      filter: '',
      // チェックした物件
      selected: []
    }
  },

  computed: {
    /**
     * 検索で絞った一覧（全角半角・スペースの違いは無視）
     */
    filteredList() {
      if (!this.filter) {
        return this.list
      }
      const key = this.normalize(this.filter)
      return this.list.filter((row) => {
        return this.normalize((row.site1 || '') + (row.site2 || '')).indexOf(key) > -1
      })
    },

    /**
     * チェック済みか
     */
    isChecked() {
      return (row) => {
        return this.selected.some((s) => s.siteCode == row.siteCode)
      }
    },

    /**
     * 契約中か
     */
    isActive() {
      return (row) => {
        return !!(row.agreementFlg && row.agreementFlg.indexOf('契約中') > -1)
      }
    }
  },

  methods: {
    /**
     * 検索用に文字を揃える（半角化して、スペースを除く）
     * @param val 文字列
     */
    normalize(val) {
      // \s は全角スペースも含む
      return utils.hankaku(String(val || '')).replace(/\s/g, '').toLowerCase()
    },

    /**
     * 行クリック（チェックの切り替え）
     * @param row 対象の物件
     */
    clickRow(row) {
      if (this.isChecked(row)) {
        this.selected = this.selected.filter((s) => s.siteCode != row.siteCode)
      } else {
        this.selected.push(row)
      }
    },

    /**
     * 表示中の物件を全選択OR解除（全選択は契約中の物件だけ）
     * @param val true：選択、false：解除
     */
    allCheck(val) {
      if (val) {
        this.filteredList.forEach((row) => {
          if (this.isActive(row) && !this.isChecked(row)) {
            this.selected.push(row)
          }
        })
      } else {
        this.selected = this.selected.filter((s) => !this.filteredList.some((row) => row.siteCode == s.siteCode))
      }
    },

    /**
     * 追加ボタン
     */
    selectedBtn() {
      this.$emit('modalSiteSelected', this.selected)
      this.closed()
    },

    /**
     * 閉じる
     */
    closed() {
      this.filter = ''
      this.selected = []
    }
  }
}
</script>

<style scoped>
  .main-height {
    max-height: 70vh;
  }

  .min-300 {
    min-width: 300px;
  }

  .b-top {
    border-top: 1px solid rgb(228, 227, 227);
  }

  .bg-colu {
    background: rgb(233, 244, 247);
  }

  .hover-color:hover {
    background: rgb(233, 244, 247);
  }
</style>
